const appConfig = {

    config: {
        development: {
            url: "https://ecommservices-dev.americanexpress.com",
            apiKeyUrl: "https://openid-dev.americanexpress.com/keys",
        }, 
        production: {
            url: "https://ecommservices.americanexpress.com",
            apiKeyUrl: "https://openid.americanexpress.com/keys",
        },      
        stage: {
            url: "https://ecommservices-qa.americanexpress.com",
            apiKeyUrl: "https://openid-qa.americanexpress.com/keys",
        }        
    }
};

export default appConfig;